import { ChevronDownIcon } from '@heroicons/react/20/solid'

type TokenSelectProps = {
  symbol: string | undefined
  showList: (show: boolean) => void
}

const QuoteTokenSelect = ({ symbol, showList }: TokenSelectProps) => {
  return (
    <button
      onClick={() => showList(true)}
      className="flex items-center text-th-fgd-3 focus-visible:outline-1 md:hover:cursor-pointer md:hover:text-th-fgd-1"
    >
      <span className="mr-1 text-xl font-bold md:text-2xl">
        {symbol || '???'}
      </span>
      <ChevronDownIcon className="size-7" />
    </button>
  )
}

export default QuoteTokenSelect
